import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../lib/cn";

const PremiumButton = ({
  variant = "primary",
  icon = true,
  className,
  children,
  href,
  onClick,
  ...props
}) => {
  const base =
    "group relative inline-flex items-center justify-center gap-2 rounded-xl px-6 py-3 text-sm md:text-[15px] font-semibold tracking-wide transition will-change-transform focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A227]/60";

  const primary =
    "bg-gradient-to-b from-[#D3B14A] to-[#B8901E] text-[#111] shadow-[0_10px_30px_rgba(0,0,0,0.35)] hover:shadow-[0_18px_40px_rgba(0,0,0,0.45)]";
  const secondary =
    "bg-white/5 text-[#F4F1E8] border border-[#C9A227]/50 backdrop-blur-md hover:border-transparent hover:bg-gradient-to-b hover:from-[#C9A227]/25 hover:to-white/5";

  const classes = cn(
    base,
    variant === "primary" ? primary : secondary,
    "hover:-translate-y-1 active:translate-y-0",
    className
  );

  const content = (
    <>
      <span
        aria-hidden="true"
        className={cn(
          "pointer-events-none absolute inset-0 overflow-hidden rounded-xl",
          variant === "primary" ? "opacity-90" : "opacity-60"
        )}
      >
        <span className="absolute -left-1/3 top-0 h-full w-2/3 rotate-12 bg-white/10 blur-xl transition-all duration-500 group-hover:left-1/2" />
      </span>

      <span className="relative z-10">{children}</span>
      {icon && (
        <span className="relative z-10 transition-transform duration-300 group-hover:translate-x-1">
          →
        </span>
      )}
    </>
  );

  if (href) {
    return (
      <Link to={href} className={classes} {...props}>
        {content}
      </Link>
    );
  }

  return (
    <button onClick={onClick} className={classes} {...props}>
      {content}
    </button>
  );
};

export default PremiumButton;
